/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Inventory_HoldInputs */

const en_create_inventory_hold = /** @type {(inputs: Create_Inventory_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Inventory Hold`)
};

const es_create_inventory_hold = /** @type {(inputs: Create_Inventory_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear apartado de inventario`)
};

/**
* | output |
* | --- |
* | "Create Inventory Hold" |
*
* @param {Create_Inventory_HoldInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const create_inventory_hold = /** @type {((inputs?: Create_Inventory_HoldInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Inventory_HoldInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_inventory_hold(inputs)
	return es_create_inventory_hold(inputs)
});